<template>
    <div class="header">
        <div class="info">
            <div class="logo">
                <img :src="$gm('logo2.png')" alt="" />
            </div>
            <div class="nav">
                <div class="nav-item" v-for="(v, i) in navList" :key="i">
                    <div class="item-info" :id="nav == i ? 'active' : ''"  @click="selectItem(v)">
                        <span class="title" v-html="v.title"></span>
                        <span v-if="v.select && v.select.length != 0" class="nav-arrow"></span>
                        <template v-if="v.select && v.select.length != 0">
                            <div class="select">
                                <div
                                    class="select-item"
                                    :class="{'en-text': lang === 'en'}"
                                    v-for="(vv, ii) in v.select"
                                    :key="ii"
                                    @click.stop="selectList(vv,ii,v.router)"
                                >
                                    <span>{{ vv.subtitle }}</span>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="login" v-if="!isLogin">
                <div @click="toLogin">{{ $t('login.homeTitle') }}</div>
            </div>
            <div v-else class="select">
                <el-dropdown trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        {{ userInfo && userInfo.mobile }}<i
                            class="el-icon-arrow-down el-icon--right"
                        ></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="1">{{ $t('common.outlogin') }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div class="language">
                <div class="language-info">
                    <span
                        @click="changeLang('zh')"
                        class="text"
                        :id="lang == 'zh' ? 'langactive' : ''"
                        >中文</span
                    >
                    <span class="sign">|</span>
                    <span
                        @click="changeLang('en')"
                        class="text"
                        :id="lang == 'en' ? 'langactive' : ''"
                        >EN</span
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            default: "0",
        },
    },
    data() {
        return {
            navList: [],
            lang: "zh",
            nav: 0,
            isLogin: false,
            userInfo:{}
        };
    },
    created() {
        this.navList = this.buildNavList()
        if (this.value) {
            this.nav = this.value;
        }
        let i18nlang = sessionStorage.getItem("i18n");
        if (i18nlang == "en" || i18nlang == "zh") {
            this.$i18n.locale = i18nlang;
            this.lang = i18nlang;
        }
        let userInfo = sessionStorage.getItem("userInfo");
        if (userInfo) {
            this.isLogin = true;
            try {
                this.userInfo = JSON.parse(userInfo);
            } catch (error) {
                this.isLogin = false;
            }
        } else {
            this.isLogin = false;
        }
    },
    methods: {
        buildNavList() {
            return [
                {
                    title: this.$t("nav.index"),
                    router: "/",
                },
                {
                    title: this.$t("nav.about"),
                    router: "/about",
                    select: [
                        {
                            subtitle: "展会介绍",
                            query: { section: "intro" },
                        },
                        {
                            subtitle: "工作动态",
                            query: { section: "news" },
                        },
                    ],
                },
                {
                    title: this.$t("nav.exhibitor"),
                    router: "/exhibitor",
                    select: [
                        {
                            subtitle: this.$t("nav.exhibitor_signup"),
                            router: "/contactUs",
                            query: { action: "contact" },
                        },
                        {
                            subtitle: this.$t("nav.exhibitor_directory_2025"),
                            query: { index: 1 },
                        },
                        {
                            subtitle: this.$t("nav.exhibitor_spotlight"),
                            query: { index: 2 },
                        },
                        {
                            subtitle: this.$t("nav.participation_manual"),
                            query: { index: 3 },
                        },
                    ],
                },
                {
                    title: this.$t("nav.activities"),
                    router:"/maneuver",
                    select: [
                        {
                            subtitle: this.$t("nav.activity_reg"),
                            externalUrl: "https://z.zcyit.cn/green/#/?regid=1191",
                        },
                        {
                            subtitle: this.$t("nav.activity_list"),
                            query: { index: 1 },
                        },
                        {
                            subtitle: this.$t("nav.activity_guide"),
                            query: { index: 2 },
                        },
                    ],
                },
                {
                    title: this.$t("nav.contact"),
                    router:'/contactUs',
                },
            ]
        },
        handleCommand(command){
            switch (command) {
                case '1':
                    this.outLogin()
                    break;
                default:
                    break;
            }
        },
        outLogin(){
            sessionStorage.clear()
            location.reload();
        },
        toLogin() {
            this.$router.push("/login");
        },
        changeLang(type) {
            this.$i18n.locale = type;
            sessionStorage.setItem("i18n", type);
            this.lang = type;
            location.reload();
        },
        selectItem(val) {
            if(val.router != this.$route.path){
                this.$router.push(val.router);
                window.scrollTo(0,0)
            }
        },
        selectList(vv,ii,router){
            if (vv.externalUrl) {
                window.open(vv.externalUrl, "_blank");
                return;
            }

            const targetRouter = vv.router ? vv.router : router;
            const query = vv.query ? vv.query : { index: ii };

            this.$router.push({
                path:targetRouter,
                query
            }).catch(() => {});
            this.$emit('select',{
                val:vv,
                index:ii,
                query
            })
        }
    },
};
</script>

<style scoped lang="less">
.logo {
    height: 60px;
    box-sizing: border-box;
    // padding: 5px 0;
    img {
        height: 60px;
    }
}
.info {
    // width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    position: fixed;
    left: 0;
    background: #fff;
    right: 0;
    z-index: 1999;
    user-select: none;
}

.nav {
    display: flex;
    padding-left: 60px;
    .item-info {
        height: 100%;
        line-height: 60px;
        padding: 0 15px;
        cursor: pointer;
        position: relative;
        display: flex;
        align-items: center;
        .title {
            font-weight: bold;
        }
    }
    #active {
        background: #1236c2;
        .title {
            color: #fff;
        }
    }
    .item-info:hover {
        background: #1236c2;

        .title {
            color: #fff;
        }
        .select {
            display: block;
        }
    }
    .select {
        position: absolute;
        left: 0;
        top: 100%;
        z-index: 99999;
        background: #eeeeee;
        // border-radius: 8px;
        display: none;
        .select-item {
            line-height: normal;
            text-align: left;
            padding: 10px 0;
            padding-left: 10px;
            min-width: 150px;
            color: #1236c2;
        }
      /* 英文菜单项加宽 */
       .select-item.en-text {
        min-width: 200px;  /* 英文宽度加大 */
        padding-right: 15px;  /* 右边增加内边距，更美观 */
        }
        .select-item:hover {
            background: #1236c2;
            color: #fff;
        }
    }
}
.nav-arrow {
    width: 8px;
    height: 8px;
    margin-left: 8px;
    margin-top: -4px;
    border-right: 2px solid currentColor;
    border-bottom: 2px solid currentColor;
    transform: rotate(45deg);
    transition: transform 0.2s ease;
}
.nav .item-info:hover .nav-arrow {
    transform: rotate(45deg) translate(1px, 1px);
}
.login {
    display: grid;
    place-items: center;
    margin-left: 30px;

    div {
        color: #1236c2;
        font-weight: bold;
        border: 1px solid #1236c2;
        padding: 8px 15px;
        cursor: pointer;
    }
}
.language {
    display: flex;
    align-items: center;
    line-height: 34px;
    padding-left: 50px;
    position: absolute; right: 5%;
    margin-left: 20px;
    .sign {
        padding: 0 8px;
    }
    span {
        cursor: pointer;
    }
    .text {
        font-weight: bold;
    }
    #langactive {
        color: #1236c2;
    }
}
.select {
    display: grid; place-items: center;
    // margin-left: 10px;
    line-height: 34px;
    .el-dropdown-link {
        cursor: pointer;
        color: #4ba1af;
    }
}
</style>
